package games.polyclub.website.frontend.store.layout

import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.tags.*
import js.core.jso
import react.Props
import web.cssom.px
import web.dom.document

val Footer = SFC<Props> { _ ->
    footer("main-footer") {
        strong {
            +"Copyright © ${js("new Date().getFullYear()")} PolyClub "
        }
        +"Todos os direitos reservados. "
        /*
        em {
            +"CNPJ 29.264.563/0001-79"
        }
        div {
            dangerouslySetInnerHTML = jso {
                __html = document.getElementById("reputation-ra")?.innerHTML ?: ""
            }
        }*/
        div("float-right d-none d-sm-inline-block") {
            style = jso {
                marginTop = (-11).px
            }
            /*b {
                +"Versão"
            }
            +" ~dev~"*/
            dangerouslySetInnerHTML = jso {
                __html = document.getElementById("reputation-ra")?.innerHTML ?: ""
            }
        }
    }

    aside("control-sidebar control-sidebar-dark")

    ProductAddedModal()
}
